<div class="form-group row">
  <div class="col-sm-3">
    <kendo-buttongroup selection="single">
      <button
        kendoButton
        [toggleable]="true"
        [(selected)]="taskOptionSelected"
        (click)="onItemSwitch()">
        Task
      </button>
      <button
        kendoButton
        [toggleable]="true"
        [(selected)]="processOptionSelected"
        (click)="onItemSwitch()">
        Process
      </button>
    </kendo-buttongroup>
  </div>

  @if (taskOptionSelected) {
    <div class="col-sm-9">
      <app-searchable-list-micro
        [selectedItems]="selectedTasks"
        [resourceUrl]="taskUrl"
        [config]="taskConfig"
        (changeValue)="changeTaskFilter($event)"></app-searchable-list-micro>
    </div>
  }

  @if (processOptionSelected) {
    <div class="col-sm-9">
      <app-searchable-list-micro
        [selectedItems]="selectedProcesses"
        [resourceUrl]="processUrl"
        [config]="processConfig"
        (changeValue)="
          changeProcessesFilter($event)
        "></app-searchable-list-micro>
    </div>
  }
</div>
